import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTuin = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M31 19h1v10h-1z"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M35.263 15.968v-.02a3.474 3.474 0 0 0-6.947 0v.02a2.026 2.026 0 1 0 0 4.012V20h6.368v-.02q.142.02.29.02a2.026 2.026 0 0 0 .29-4.033"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M24 28h12v2H24z"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M6 16.154 15 10l9 6.154V30H6z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M15.15 20h-6v10h6z"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M28.365 25.857v.411l.235-.24a.8.8 0 0 1 1.165.013.88.88 0 0 1-.035 1.234l-.71.725h-3.04l-.71-.724-.023-.023a.88.88 0 0 1-.011-1.212.8.8 0 0 1 1.164-.012l.318.324v-.496c0-.473.369-.857.824-.857s.823.384.823.857"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTuin);

export default ForwardRef;
